var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#white-rounded_svg__clip0_1210_18314)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z",
  fill: "url(#white-rounded_svg__paint0_linear_1210_18314)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 0C8.971 0 0 8.971 0 20c0 .686.057 1.371.114 2 1.2-.743 2.4-1.6 3.543-2.743C8.286 14.63 10.4 12.514 14.8 12.514c2.514 0 4.286.686 6.171 2.115 1.429 1.085 2.972 2.628 4.972 4.628C31.314 24.571 38.286 24.8 39.37 24.8h.058c.4-1.543.571-3.2.571-4.857C40 8.97 31.029 0 20 0z",
  fill: "url(#white-rounded_svg__paint1_linear_1210_18314)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.914 14.686c-3.085.628-5.2 2.743-9.028 6.571-3.657 3.657-8.057 4.914-10.8 5.314a19.932 19.932 0 01-1.029-4.514c1.2-.686 2.4-1.6 3.543-2.743 4.629-4.628 6.743-6.743 11.143-6.743 2.514-.057 4.286.629 6.171 2.115z",
  fill: "url(#white-rounded_svg__paint2_linear_1210_18314)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.429 24.857C37.257 33.543 29.37 40 20 40c-8.743 0-16.171-5.6-18.914-13.429 2.8-.457 7.2-1.714 10.8-5.314 3.828-3.828 5.943-5.943 9.028-6.571 1.429 1.085 2.972 2.628 4.972 4.628 5.543 5.429 12.685 5.543 13.543 5.543z",
  fill: "url(#white-rounded_svg__paint3_linear_1210_18314)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.229 21.2c-4.629-4.629-6.743-6.743-11.143-6.743-.8 0-1.486.057-2.115.229 1.429 1.085 2.972 2.628 4.972 4.628 5.486 5.486 12.628 5.543 13.486 5.543-1.772-.857-3.543-2-5.2-3.657z",
  fill: "#01DBFF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint0_linear_1210_18314",
  x1: 0,
  y1: 20,
  x2: 40,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0067D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008FDD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint1_linear_1210_18314",
  x1: 0,
  y1: 12.425,
  x2: 40,
  y2: 12.425,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0067D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#008FDD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint2_linear_1210_18314",
  x1: 2.569,
  y1: 33.943,
  x2: 15.067,
  y2: 9.415,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0D67CB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.008,
  stopColor: "#1067CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.401,
  stopColor: "#8F679A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#DF677B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.791,
  stopColor: "#FF676F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862,
  stopColor: "#FF676A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint3_linear_1210_18314",
  x1: 13.652,
  y1: 39.215,
  x2: 25.082,
  y2: 16.782,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#166ECD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.207,
  stopColor: "#4F75BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.238,
  stopColor: "#5B78B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#9F87A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.553,
  stopColor: "#CA909B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#DA9497"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.673,
  stopColor: "#E0A099"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.904,
  stopColor: "#FFCCA1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.951,
  stopColor: "#FFD3A1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "white-rounded_svg__clip0_1210_18314"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#fff"
})))));
export default "data:image/svg+xml;base64,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";
export { SvgWhiteRounded as ReactComponent };